import {
  SideBarItemType,
  SIDEBAR_ITEMS,
  SIDEBAR_ITEMS_DEPRECATED,
  type ISideBarItem,
} from '../constants/sideBarItems';
import type { TemplateTab } from '../types/TemplateTabs';

export const tabsByIdMapper: Record<TemplateTab, ISideBarItem> =
  SIDEBAR_ITEMS_DEPRECATED.reduce(
    (acc, tab) => ({
      ...acc,
      ...(tab.type !== SideBarItemType.HEADING && {
        [tab.id]: tab,
      }),
    }),
    {} as Record<TemplateTab, ISideBarItem>,
  );

export const tabsByIdMapperNew: Record<TemplateTab, ISideBarItem> =
  SIDEBAR_ITEMS.reduce(
    (acc, tab) => ({
      ...acc,
      ...(tab.type !== SideBarItemType.HEADING && {
        [tab.id]: tab,
      }),
    }),
    {} as Record<TemplateTab, ISideBarItem>,
  );
